import compact from 'lodash/compact'
import moment from 'moment-timezone'
import {
  IShipmentStopRelayedByTypes,
  IShipmentStopRelayedViaTypes,
  Maybe,
} from 'types/graphqlTypes'
import { FORMATS } from 'constants/datetime'

export const isLateForAppointment = (
  input: { time: string | null; date: string | null },
  timezone: string,
  appointment: string
) => {
  if (!appointment || !input?.time || !input?.date) {
    return false
  }
  const appointmentMoment = moment.tz(appointment, timezone).format('YYYY-MM-DD HH:mm')
  const inputTime = moment(`${moment(input.date).format(FORMATS.yearFirst)} ${input.time}`)

  return inputTime.isAfter(appointmentMoment)
}

interface INote {
  date: string | null
  time: string | null
  lateReason: string | null
  body: string | null
  location: string | null
  miles: string | null
  dateLabel?: Maybe<string>
  relayedBy?: Maybe<IShipmentStopRelayedByTypes>
  relayedVia?: Maybe<IShipmentStopRelayedViaTypes>
}

export const convertToNote = ({
  body,
  date,
  dateLabel = 'Pickup ETA',
  lateReason,
  location,
  miles,
  relayedBy,
  relayedVia,
  time,
}: INote) => {
  const prefixedPickupEta = `${dateLabel}: ${moment(date).format(FORMATS.yearFirst)} at ${time}`
  const prefixedLateReason = lateReason ? `Late Reason: ${lateReason}` : ''
  const prefixedBody = body ? `Note: ${body}` : ''
  const prefixedLocation = location ? `Current location: ${location}` : ''
  const prefixedMiles = miles ? `Miles to go: ${miles}` : ''
  const prefixedRelayedBy = relayedBy ? `Relayed by: ${relayedBy}` : ''
  const prefixedRelayedVia = relayedVia ? `Relayed via: ${relayedVia}` : ''

  return compact([
    prefixedPickupEta,
    prefixedLateReason,
    prefixedBody,
    prefixedLocation,
    prefixedMiles,
    prefixedRelayedBy,
    prefixedRelayedVia,
  ]).join(' - ')
}

export const is24HrTimeValid = (time: string) => {
  // from 00:00 to 23:59
  const time24HrFormat = /(?:[01][0-9]|2[0-3]):[0-5][0-9]/
  return time24HrFormat.test(time)
}
